import { configureStore } from "state";
import { reducers } from "state/reducers";
import coreSagas from "state/sagas";
import cmsSagas from "cms/state/sagas";
//import joyntSagas from "joynt/state/sagas";

const sagas = [...coreSagas, ...cmsSagas];

export const { store, history } = configureStore({}, { reducers, sagas });
